/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_DescriptionInputs */

const en_directory_taxonomy_use_cases_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore product paths for common creative, technical, research, and launch workflows.`)
};

const zh_directory_taxonomy_use_cases_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索适用于创作、技术、研究和产品发布等常见工作流的产品路径。`)
};

/**
* | output |
* | --- |
* | "Explore product paths for common creative, technical, research, and launch workflows." |
*
* @param {Directory_Taxonomy_Use_Cases_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_description(inputs)
	return zh_directory_taxonomy_use_cases_description(inputs)
});
export { directory_taxonomy_use_cases_description as "directory.taxonomy.use-cases.description" }